import { mathUtils, type Optional } from '@festina-life/core'

import type { ExpressionTypeInformation } from '../../fplusExpression/types'

export const getSimulatedFunctionForParameter = (
  parameterTypeInformation: ExpressionTypeInformation,
  parameterType: string,
) => {
  const requiredParameterMaps = new Map<string, string>() // We need to gather a collection of all required parameters and their types
  const functionName = generateRandomString(20)

  const collectFunctionParameters = (
    expressionTypeInformation: ExpressionTypeInformation,
  ) => {
    // Currently FPlus doesn't allow parameter to cross reference each other so we'll leave this commented out.
    // In the future this will likely be enabled for FPlus and we'll simply have to enable it here.
    // if (expressionTypeInformation.type === 'constructor') {
    //   expressionTypeInformation.parameters.forEach((parameter) => {
    //     // We iterate from deep parameters up to the root and therefore respect the type of the deepes parameter if there is a name collision
    //     if (!requiredParameterMaps.has(parameter.name)) {
    //       const typeName = parameter.type?.typeName ?? ''
    //       const parameterType =
    //         parameter.cardinality === 'many' ? `List<${typeName}>` : typeName
    //       requiredParameterMaps.set(parameter.name, parameterType)
    //     }
    //   })
    // }

    if (expressionTypeInformation.functionMetadata) {
      expressionTypeInformation.functionMetadata.parameters.forEach(
        (parameter) => {
          // We iterate from deep parameters up to the root and therefore respect the type of the deepest parameter if there is a name collision
          if (!requiredParameterMaps.has(parameter.name) && parameter.type) {
            requiredParameterMaps.set(parameter.name, parameter.type)
          }
        },
      )
    }
  }

  let currentExpression: Optional<ExpressionTypeInformation> =
    parameterTypeInformation

  do {
    collectFunctionParameters(currentExpression)
    currentExpression = currentExpression.parent
  } while (currentExpression)

  return `${functionName}(${requiredParameterMaps
    .entries()
    .map(
      ([parameterName, parameterType]) => `${parameterName}: ${parameterType}`,
    )
    .toArray()
    .join(', ')}): ${parameterType}`
}

export const generateRandomString = (length: number): string => {
  const characters = 'abcdefghijklmnopqrstuvwxyz'
  let result = ''
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(mathUtils.random() * characters.length)
    result += characters[randomIndex]
  }
  return result
}
